/* eslint-disable no-var */

//@ts-expect-error
const initGTM = (w, d, s, l, i) => {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  var j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  if (document.head.firstChild) {
    document.head.insertBefore(j, document.head.firstChild);
  } else {
    document.head.appendChild(j);
  }
};

const insertGTMiframe = (gtmId: string) => {
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  if (document.body.firstChild) {
    document.body.insertBefore(noscript, document.body.firstChild);
  } else {
    document.body.appendChild(noscript);
  }
};

const setupGTM = (gtmId: string) => {
  if (typeof window === 'undefined' || !gtmId) {
    return;
  }

  initGTM(window, document, 'script', 'dataLayer', gtmId);
  insertGTMiframe(gtmId);
};

export default setupGTM;
